import React from "react";
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Card from "@material-ui/core/Card";
import { signInAction, changePasswordAction } from "store/actions";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import { modifyDocumentTitle } from "components/utils";
import UpdatePassword from "components/user/UpdatePassword";
import HiddenOn from "components/common/HiddenOn";
import get from "lodash/get";

export const Login = ({
  signIn,
  message,
  error,
  reqPwdChange,
  userData,
  changePwd,
}) => {
  modifyDocumentTitle("Login");

  const [state, setState] = React.useState({
    username: "",
    password: "",
    showPassword: false,
  });

  const handleChange = (prop) => {
    //this is technically abusing state, but I don't care at this point
    //this took way too long to get working
    prop.forEach((item): any => {
      const key = Object.entries(item)[0][0];
      const value = Object.entries(item)[0][1];
      state[`${key}`] = value;
    });
    setState({ ...state });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = () =>
    signIn({
      username: state.username,
      password: state.password,
    });

  if (reqPwdChange) {
    return (
      <UpdatePassword
        userData={userData}
        changePwd={changePwd}
        error={error}
        message={message}
      />
    );
  }

  return (
    <StyledCard>
      <div>
        <InputLabel htmlFor="standard-adornment-username">Username</InputLabel>
        <Input
          id="standard-adornment-username"
          type={"text"}
          value={state.username}
          onChange={(i) => {
            handleChange([{ username: i.target.value }]);
          }}
          onKeyPress={(event) => {
            if (event.which === 13) {
              handleSubmit();
              event.preventDefault();
            }
          }}
        />
      </div>
      <div>
        <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
        <Input
          id="standard-adornment-password"
          type={state.showPassword ? "text" : "password"}
          value={state.password}
          onChange={(i) => {
            handleChange([{ password: i.target.value }]);
          }}
          onKeyPress={(event) => {
            if (event.which === 13) {
              handleSubmit();
              event.preventDefault();
            }
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={(i) => {
                  handleChange([{ showPassword: !state.showPassword }]);
                }}
                onMouseDown={handleMouseDownPassword}
              >
                {state.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
      </div>
      <span>
        <HiddenOn hideOn={!error}>
          <StyledError>{message}</StyledError>
        </HiddenOn>
        <Button color={"primary"} onClick={handleSubmit}>
          Sign In
        </Button>
      </span>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-self: center;
  padding: 20px;
  margin-top: 100px;

  > span {
    text-align: center;
    > button {
      margin-top: 10px;
      width: 75%;
    }
  }

  > div {
    margin-top: 10px;
  }
`;
const StyledError = styled.div`
  color: red;
  font-size: 14px;
  margin-top: 10px;
`;

const mapStateToProps = (state) => ({
  error: get(state, "rootReducer.core.user.error"),
  message:
    get(state, "rootReducer.core.user.data.message") ||
    get(state, "rootReducer.core.user.data.log"),
  reqPwdChange: get(state, "rootReducer.core.user.reqPwdChange", false),
  userData: get(state, "rootReducer.core.user.userData"),
});

const mapDispatchToProps = {
  signIn: signInAction,
  changePwd: changePasswordAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
